import FieldPresenceValidator from "../navigableValidators/fieldPresenceValidator";
import NavigableValidation from "./navigableValidation";
import UrlValidator from "../navigableValidators/urlValidator";
import SlugValidator from "../navigableValidators/slugValidator";
import EmbeddedCollectionValidator from "../navigableValidators/embeddedCollectionValidator";
import MinMaxFieldValidator from "../navigableValidators/minMaxFieldValidator";
import { minMaxType } from "~/enums/minMaxValidatorType";
import PublicProfile from "../publicProfile/publicProfile";
import { ValidationModalSection } from "~/models/navigableValidations/validationSections";

export default class PublicProfileValidation extends NavigableValidation<PublicProfile> {
  validators = [
    new FieldPresenceValidator({
      validatorKey: "title",
      displayName: "Title",
      section: ValidationModalSection.Definition
    }),
    new FieldPresenceValidator({
      validatorKey: "application_type",
      section: ValidationModalSection.Layout
    }),
    new FieldPresenceValidator({
      validatorKey: "description",
      section: ValidationModalSection.Layout
    }),
    new FieldPresenceValidator({
      validatorKey: "min_cost",
      section: ValidationModalSection.Layout,
      conditionalField: "cost_type",
      conditionalValue: 1
    }),
    new FieldPresenceValidator({
      validatorKey: "max_cost",
      section: ValidationModalSection.Layout,
      conditionalField: "cost_type",
      conditionalValue: 1
    }),
    new FieldPresenceValidator({
      validatorKey: "apply_section_header",
      section: ValidationModalSection.Layout,
    }),
    new FieldPresenceValidator({
      validatorKey: "apply_sub_text",
      section: ValidationModalSection.Layout,
    }),
    new FieldPresenceValidator({
      validatorKey: "apply_button_label",
      section: ValidationModalSection.Layout,
    }),
    new UrlValidator({
      validatorKey: "application_url",
      section: ValidationModalSection.Layout
    }),
    new UrlValidator({
      validatorKey: "pdf_url",
      section: ValidationModalSection.Layout,
    }),
    new EmbeddedCollectionValidator({
      validatorKey: "resources",
      section: ValidationModalSection.Layout
    }, this.model),
    new SlugValidator({
      validatorKey: "seo_url",
      section: ValidationModalSection.Layout
    }),

    new MinMaxFieldValidator({
      validatorKey: "min_completion_time",
      section: ValidationModalSection.Layout,
      min_field: "min_completion_time",
      max_field: "max_completion_time",
      minMaxType: minMaxType.duration,
      min_field_unit: "min_completion_time_unit",
      max_field_unit: "max_completion_time_unit"
    }),
    new MinMaxFieldValidator({
      validatorKey: "min_approval_time",
      section: ValidationModalSection.Layout,
      min_field: "min_approval_time",
      max_field: "max_approval_time",
      minMaxType: minMaxType.duration,
      min_field_unit: "min_approval_time_unit",
      max_field_unit: "max_approval_time_unit"
    }),
    new MinMaxFieldValidator({
      validatorKey: "min_cost",
      section: ValidationModalSection.Layout,
      min_field: "min_cost",
      max_field: "max_cost",
      minMaxType: minMaxType.currency,
      conditional_field: "cost_type",
      conditionalValue: 1
    })
  ];
}
